import "./AboutServiceTab.css";

import CustomLabelSection from "../../../Components/CustomLabelSection/CustomLabelSection";
import PlanComparisonTable from "./PlanComparisonTable/PlanComparisonTable";

import { TextWithLineBreaks } from "../../../Components/TextWithLineBreaks";
import RoundedBox from "../../../Components/RoundedBox/RoundedBox";

function AboutServiceTab({ }) {
    const CustomRoundBoxStyle = {
        backgroundColor: 'transparent',
        border: '1px solid #EFF2F9',
    };

    return (
        <div className="about-service-tab">
            <div className="about-service-tab-title">
                아마존 킨들 출판 대행 서비스란?
            </div>
            <div className="about-service-tab-desc">
                <TextWithLineBreaks text={"한글 원고 하나로, 전 세계 독자와 만나는 가장 빠른 길\n 아마존 KDP 출판 전문가와 지금, 시작하세요!"} />
            </div>

            <div className="about-service-tab-spacer" />

            <div className="about-service-tab-title">
                서비스 구성
            </div>

            <div className="about-service-tab-offerings-row">
                <RoundedBox>
                    <label>전문 번역, 편집, 표지 디자인</label>
                </RoundedBox>
                <RoundedBox>
                    <TextWithLineBreaks text={"전자책(ePub) + 종이책(POD) 동시 출판 가능 \n(최대 1개월 내)"} />
                </RoundedBox>
                <RoundedBox>
                    <TextWithLineBreaks text={"저자 인세 100% 보장 \n(전자책 최대 70%, 종이책 60%)"} />
                </RoundedBox>
                <RoundedBox>
                    <TextWithLineBreaks text={"전 세계 12개국 아마존 마켓 자동 노출"} />
                </RoundedBox>
            </div>

            <PlanComparisonTable />

            <div className="about-service-tab-spacer" />

            <div className="about-service-tab-title">
                왜 아마존 킨들 출판 대행이 필요한가요?
            </div>

            <div className="about-service-tab-wrapper">
                <div className="about-service-tab-benefits">
                    <div className="about-service-tab-benefits-title">전문 관리를 통한</div>
                    <div className="about-service-tab-benefits-circles">
                        <div className="about-service-tab-circle">출판 시간 단축</div>
                        <div className="about-service-tab-plus">+</div>
                        <div className="about-service-tab-circle">성공률 향상</div>
                    </div>
                </div>

                <div className="about-service-tab-offerings-col">
                    <RoundedBox>
                        <label>영어 원고 포함 메타데이터 / 마케팅 카피 / 키워드 작성</label>
                    </RoundedBox>
                    <RoundedBox>
                        <label>표지 / 판형 / 포맷팅 / ISBN / 로열티 세팅 / 판매 보고 관리</label>
                    </RoundedBox>
                </div>
            </div>

            <div className="about-service-tab-spacer" />

            <div className="about-service-tab-title">
                이런 분들에게 추천합니다!
            </div>

            <div className="about-service-tab-offerings-grid">
                <RoundedBox style={CustomRoundBoxStyle}>
                    <label>영어권 독자나 글로벌 시장을 목표로 하는 분</label>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <label>기존 도서를 해외 독자용으로 재출판하고 싶은 분</label>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <label>아마존 검색·리뷰 시스템을 통해 수익을 내고 싶은 분</label>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <label>기술서, 자기계발서, 번역 콘텐츠로 전문성을 수출하고 싶은 분</label>
                </RoundedBox>
            </div>
            <CustomLabelSection label={"알고 시작하는 사람과,\n 모르고 뛰어드는 사람의 결과는 다릅니다."}/>
        </div>
    );
}

export default AboutServiceTab;